import { PageContext } from 'context/PageContext';
import { memo, useContext } from 'react';

export const BasketPage: React.FC<PageModel> = memo(() => {
	const pageContext = useContext(PageContext);
	// The generic PageModel does not carry the basket-specific fields; this
	// template is only rendered when contentType === 'BasketPage', so it is
	// safe to narrow to the dedicated model here.
	const pageModel = pageContext?.pageModel as BasketPageModel | undefined;

	const headline = pageModel?.headline;
	const description = pageModel?.description;
	const productOverviewArea = pageModel?.productOverviewArea ?? [];
	const ruleEngineArea = pageModel?.ruleEngineArea;
	const campaignArea = pageModel?.campaignArea;
	const priceSummaryArea = pageModel?.priceSummaryArea;

	return (
		<div data-page-type='BasketPage'>
			{headline && <h1>{headline}</h1>}
			{description && <div dangerouslySetInnerHTML={{ __html: description }} />}

			<section data-testid='basket-product-overview-area'>
				<h2>Product Overview</h2>
				{productOverviewArea.length > 0 && (
					<ul>
						{productOverviewArea.map((item, index) => (
							<li key={item.salesProduct ?? item.productName ?? index}>
								<dl>
									<dt>
										<strong>productName</strong>
									</dt>
									<dd>{item.productName}</dd>
									<dt>
										<strong>salesProduct</strong>
									</dt>
									<dd>{item.salesProduct}</dd>
									<dt>
										<strong>postPriceArea sections</strong>
									</dt>
									<dd>{item.postPriceArea?.items?.length ?? 0}</dd>
								</dl>
							</li>
						))}
					</ul>
				)}
			</section>

			<section data-testid='basket-rule-engine-area'>
				<h2>Rule Engine</h2>
				{ruleEngineArea?.items?.map((component) => (
					<div key={component.content.contentId}>{component.content.contentType}</div>
				))}
			</section>

			<section data-testid='basket-campaign-area'>
				<h2>Campaigns</h2>
				{campaignArea?.items?.map((component) => (
					<div key={component.content.contentId}>{component.content.contentType}</div>
				))}
			</section>

			<section data-testid='basket-price-summary-area'>
				<h2>Price Summary</h2>
				{priceSummaryArea?.items?.map((component) => (
					<div key={component.content.contentId}>{component.content.contentType}</div>
				))}
			</section>
		</div>
	);
});

BasketPage.displayName = 'BasketPage';
